import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/71750
const trackBioLinkClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'bioLink',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71736
const trackAboutMeEditProfileClick = (isPersonalView: boolean) => {
  sendUIEvent({
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'aboutMeEditProfile',
    isPersonalView,
    source: SCREEN_NAME.PROFILE,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71745
const trackSocialLinkClick = (linkType: string, isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'socialLink',
    attributes: {
      linkType,
    },
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84848
const trackEventClick = (isPersonalView: boolean) => {
  sendUIEvent({
    source: SCREEN_NAME.PROFILE,
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'eventsLinkProfile',
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71749
const trackProductPillClick = (
  productId: string,
  isPersonalView: boolean,
  source: SCREEN_NAME,
) => {
  sendUIEvent({
    source,
    action: 'clicked',
    actionSubject: 'pill',
    actionSubjectId: 'productPill',
    attributes: {
      productId,
    },
    isPersonalView,
  });
};

export {
  trackBioLinkClick,
  trackAboutMeEditProfileClick,
  trackSocialLinkClick,
  trackEventClick,
  trackProductPillClick,
};
